var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 3164,
    height: 1052,
    viewBox: "0 0 3164 1052",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1445.13 1052H1718.87L1582 526L1445.13 1052Z",
    fill: "#EDECE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2008.54 1052H2318.66L1582 526L2008.54 1052Z",
    fill: "#EDECE4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2692.14 1052H3159.97L1582 526L2692.14 1052Z",
    fill: "#EDECE4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3164 894.066V772.466L1582 526L3164 894.066Z",
    fill: "#EDECE4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1582 526L3164 666.534V572.704L1582 526Z",
    fill: "#EDECE4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3164 479.296V385.466L1582 526L3164 479.296Z",
    fill: "#EDECE4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3164 279.534V157.934L1582 526L3164 279.534Z",
    fill: "#EDECE4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3159.97 0H2692.14L1582 526L3159.97 0Z",
    fill: "#EDECE4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2318.66 0H2008.54L1582 526L2318.66 0Z",
    fill: "#EDECE4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1718.87 0H1445.13L1582 526L1718.87 0Z",
    fill: "#EDECE4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1155.46 0H845.344L1582 526L1155.46 0Z",
    fill: "#EDECE4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M471.857 0H4.02545L1582 526L471.857 0Z",
    fill: "#EDECE4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 157.934V279.534L1582 526L0 157.934Z",
    fill: "#EDECE4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 385.466V479.296L1582 526L0 385.466Z",
    fill: "#EDECE4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 572.704V666.534L1582 526L0 572.704Z",
    fill: "#EDECE4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0 772.466V894.066L1582 526L0 772.466Z",
    fill: "#EDECE4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M4.02545 1052H471.857L1582 526L4.02545 1052Z",
    fill: "#EDECE4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M845.344 1052H1155.46L1582 526L845.344 1052Z",
    fill: "#EDECE4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.141025df.svg";
export { ForwardRef as ReactComponent };